import React, { useEffect, useState } from 'react';
import { Modal, Table, Tag, message } from 'antd';
import { AiOutlinePlus, AiOutlineEdit, AiOutlineDelete } from 'react-icons/ai';
import DeleteModal from '../../Components/Modal/DeleteModal';
import AddEditExpense from './components/addEditExpense';
import Service from '../../../../Service';
import moment from 'moment';
import 'moment/locale/tr';
import usePermission from '../../../../Utils/usePermission';

const Expenses = () => {
    moment.locale('tr');
    
    const { canCreate, canEdit, canDelete } = usePermission();
    const [selectedId, setSelectedId] = useState(null);
    const [selectedExpense, setSelectedExpense] = useState(null);
    const [isModal, setIsModal] = useState(false);
    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [update, setUpdate] = useState(false);
    const [data, setData] = useState({ results: [], totalPages: 0, currentPage: 1 });
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const pageSize = 10;

    useEffect(() => {
        fetchExpenses();
    }, [currentPage, update]);

    const fetchExpenses = async () => {
        setLoading(true);
        try {
            const service = new Service();
            const response = await service.ExpenseService.getExpenses(`page=${currentPage}&pageSize=${pageSize}`);
            setData(response);
        } catch (error) {
            message.error('Harcamalar yüklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const onEditExpense = (expense) => {
        setSelectedExpense(expense);
        setIsModal(true);
    };

    const onDeleteExpense = (id) => {
        setSelectedId(id);
        setIsDeleteModal(true);
    };

    const handleDelete = async () => {
        try {
            const service = new Service();
            await service.ExpenseService.deleteExpense(selectedId);
            message.success('Harcama başarıyla silindi');
            setUpdate(!update);
            setIsDeleteModal(false);
        } catch (error) {
            message.error('Harcama silinirken hata oluştu');
        }
    };

    const columns = [
        {
            title: 'Tarih',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => moment(text).format('DD.MM.YYYY HH:mm'),
        },
        {
            title: 'Açıklama',
            dataIndex: 'desc',
            key: 'desc',
        },
        {
            title: 'Tutar',
            dataIndex: 'amount',
            key: 'amount',
            render: (amount) => `${amount} ₺`,
        },
        {
            title: 'Kategori',
            dataIndex: 'category',
            key: 'category',
            render: (category) => <Tag color="blue">{category}</Tag>,
        },
        {
            title: 'İşlemler',
            key: 'actions',
            align: 'center',
            width: 150,
            render: (_, record) => (
                <div className="flex space-x-2">
                    {canEdit && (
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded text-sm"
                            onClick={() => onEditExpense(record)}
                        >
                            <AiOutlineEdit />
                        </button>
                    )}
                    {canDelete && (
                        <button
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-3 rounded text-sm"
                            onClick={() => onDeleteExpense(record.id)}
                        >
                            <AiOutlineDelete />
                        </button>
                    )}
                </div>
            ),
        },
    ];

    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold">Harcamalar</h1>
                <div>
                    {canCreate && (
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center"
                            onClick={() => {
                                setSelectedExpense(null);
                                setIsModal(true);
                            }}
                        >
                            <AiOutlinePlus className="mr-2" />
                            Yeni Harcama
                        </button>
                    )}
                </div>
            </div>

            <Table
                columns={columns}
                dataSource={data.results}
                rowKey="id"
                loading={loading}
                pagination={{
                    current: currentPage,
                    total: data.totalPages * pageSize,
                    pageSize: pageSize,
                    onChange: (page) => setCurrentPage(page),
                    showSizeChanger: false,
                    showTotal: (total, range) => `${range[0]}-${range[1]} / ${total} kayıt`,
                }}
            />

            <Modal
                title={selectedExpense ? 'Harcama Düzenle' : 'Yeni Harcama'}
                open={isModal}
                onCancel={() => setIsModal(false)}
                footer={null}
                width={500}
            >
                <AddEditExpense
                    expense={selectedExpense}
                    onSuccess={() => {
                        setIsModal(false);
                        setUpdate(!update);
                    }}
                />
            </Modal>

            <DeleteModal
                isOpen={isDeleteModal}
                onClose={() => setIsDeleteModal(false)}
                onDelete={handleDelete}
                title="Harcama Sil"
                description="Bu harcamayı silmek istediğinizden emin misiniz?"
            />
        </div>
    );
};

export default Expenses; 